<template>
    <div>
        <section class="main-slider">
            <div class="page-header-bg"   style="background-image: url(static/picture/banner/B5.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                         <!-- 行业标准 -->
                         {{ $t('header.industryStandards') }}
                    </h1>
                    <h3>
                        <!-- 全球重要的焊接标准认证 -->
                         {{ $t('resource.resource_standard_banner_subtitle') }}
                    </h3>
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'mb_home' }">
                             <!-- 首页 -->
                            {{ $t('header.home') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item >
                             <!-- 行业标准 -->
                            {{ $t('header.industryStandards') }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>
    
        <!-- 内容 -->
        <section class="service-details">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12 col-lg-12">
                        <div class="service-details__left">
                            <div class="service-details__service">
                                <h3 class="service-details__title">
                                     <!-- 行业标准 -->
                                    {{ $t('resource.resource_standard_title') }}
                                </h3>
                                <ul class=" list-unstyled">
                                    <li ><a target="_blank"  href="https://openstd.samr.gov.cn/bzgk/gb/std_list?p.p1=0&p.p90=circulation_date&p.p91=desc&p.p2=%E5%8E%8B%E5%8A%9B%E5%AE%B9%E5%99%A8">
                                          <!-- 压力容器行业标准  -->
                                        {{ $t('resource.resource_standard_pressureVessel') }}
                                        <span class="fa fa-long-arrow-alt-right"></span></a></li>

                                    <li><a  target="_blank"  href="https://openstd.samr.gov.cn/bzgk/gb/std_list?p.p1=0&p.p90=circulation_date&p.p91=desc&p.p2=%E9%92%A2%E7%BB%93%E6%9E%84">
                                         <!-- 钢结构行业标准 -->
                                        {{ $t('resource.resource_standard_steelStructure') }}
                                        <span class="fa fa-long-arrow-alt-right"></span></a></li>

                                    <li><a target="_blank"  href="https://openstd.samr.gov.cn/bzgk/gb/std_list?p.p1=0&p.p90=circulation_date&p.p91=desc&p.p2=%E9%80%A0%E8%88%B9" >
                                         <!-- 造船行业标准 -->
                                         {{ $t('resource.resource_standard_ship') }}
                                        <span class="fa fa-long-arrow-alt-right"></span></a></li>

                                    <li><a target="_blank"  href="https://openstd.samr.gov.cn/bzgk/gb/std_list?p.p1=0&p.p90=circulation_date&p.p91=desc&p.p2=%E6%9C%BA%E6%A2%B0%E5%88%B6%E9%80%A0">
                                         <!-- 机械制造行业标准 -->
                                        {{ $t('resource.resource_standard_machinery') }}
                                        <span class="fa fa-long-arrow-alt-right"></span></a></li>

                                    <li><a target="_blank"  href="https://openstd.samr.gov.cn/bzgk/gb/std_list?p.p1=0&p.p90=circulation_date&p.p91=desc&p.p2=%E6%A0%B8%E7%94%B5">
                                        <!-- 核电行业标准 -->
                                        {{ $t('resource.resource_standard_nuclear') }}
                                        <span class="fa fa-long-arrow-alt-right"></span></a></li>
                                    <li><a target="_blank"  href="https://openstd.samr.gov.cn/bzgk/gb/std_list?p.p1=0&p.p90=circulation_date&p.p91=desc&p.p2=%E7%AE%A1%E9%81%93">
                                         <!-- 管道行业标准 -->
                                        {{ $t('resource.resource_standard_piping') }}
                                        <span class="fa fa-long-arrow-alt-right"></span></a></li>

                                </ul>
                            </div>
                           
                           
                        </div>
                    </div>
                
                </div>
            </div>
        </section>
    </div>
</template>

<script >
export default {
    name: 'mbIndustry',
    data () {
        return {
        }
    },
    created() {
        // this.getList()  // 获取内容
    },
    mounted () {},
    methods: {
        // 获取内容
        getList() {
        
        },
      
       
       
    }
}
</script>
<style scoped>
.page-header-bg {
    background-color: transparent;  
}
.page-header__inner h1 {
    text-align: center;
    font-size: var(--font-size-20) !important;
    text-justify: distribute-all-lines;  /*兼容ie*/
}
.page-header__inner h3 {
    font-size: 16px;
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
}
.main-slider .container {
    padding-top: 120px;
    padding-bottom: 120px;
}
.list-unstyled {
    cursor: pointer;
}
/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    /* color: var(--notech-primary) !important; */
    color: var(--notech-white);
    font-size: var(--font-size-16);
    font-weight: 700;
    transition: all 500ms ease;
}
.service-details {
    padding: 60px 0 0 ;
}
.service-details__title {
    margin-bottom: 20px;
}
.service-details__service {
    padding: 30px;
}
 li a span {
    float: right;
    line-height: 30px;
    color: var(--notech-base);
}
</style> 
